<div class="data-explorer-container">
  <div class="result-container">
    <!-- Chart view: Predefined charts (visible when in visualization/chart view) -->
    <section class="predefined-charts-section" *ngIf="!_tableViewFlag()">
      <app-predefined-charts-container
        [payload]="predefinedChartsPayload"
      />
    </section>
  </div>
</div>
